import React from "react";
import {Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@mui/material";
import {SectionTitle} from "../../../export/advanced_export";
import EnhancedSelect from "../../../../../../components/EnhancedSelect";
import NavigationButtons from "./NavigationButtons";
import cloneDeep from 'lodash/cloneDeep';
import { tableCellTruncateSx, pageContentGap } from "../../../../../../theme";
import type { WizardSharedProps } from "../types";

// region TypeScript Interfaces
type SelectCategoryProps = WizardSharedProps;
// endregion

export default function SelectCategory(props: SelectCategoryProps) {
    const {allowBack, allowNext, backStep, nextStep, activeStep, steps, setSteps} = props;

    const {profile, formattedProfile, profileType} = props;
    const {parsedFields} = props;

    const onNext = () => {
        setSteps((prevState) => {
            let newState = cloneDeep(prevState);
            newState[activeStep].status = "success";
            return newState;
        });
    }

    return (
        <Grid container style={{gap: pageContentGap}}>
            <Paper style={{width: "100%", padding: "24px", borderRadius: "5px"}}>
                <Grid container>
                    <SectionTitle style={{marginBottom: "24px"}}>
                        Sample Data Preview
                    </SectionTitle>

                    <Grid container style={{maxWidth: "calc(100vw - 26em)", overflow: "auto"}}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {parsedFields.map((field, index) => {
                                        return (
                                            <TableCell key={index}>
                                                <Typography>
                                                    {field.field}
                                                </Typography>
                                            </TableCell>
                                        )
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    {parsedFields.map((field, index) => {
                                        return (
                                            <TableCell key={index} sx={tableCellTruncateSx}>
                                                <Typography>
                                                    {field.content}
                                                </Typography>
                                            </TableCell>
                                        )
                                    })}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
            </Paper>

            <Paper style={{width: "100%", padding: "24px", borderRadius: "5px"}}>
                <Grid container style={{flexDirection: "column", alignItems: "flex-start", width: "100%"}}>
                    <SectionTitle style={{marginBottom: "12px"}}>
                        Category from Import
                    </SectionTitle>

                    <Grid container style={{width: "100%"}}>
                        <EnhancedSelect
                            placeholder={"Category Column"}
                            value={{
                                label: profile.Category,
                                value: profile.Category
                            }}
                            options={parsedFields.map((field, index) => {
                                return {
                                    label: field.field,
                                    value: field.field
                                }
                            })}
                            onChange={(e: any) => {
                                if (e == null) {
                                    props.setProfile({
                                        ...profile,
                                        Category: "",
                                        AttributeMappings: {
                                            ...profile.AttributeMappings,
                                            category: ""
                                        }
                                    });
                                    return;
                                }

                                props.setProfile({
                                    ...profile,
                                    Category: e.value,
                                    AttributeMappings: {
                                        ...profile.AttributeMappings,
                                        category: e.value
                                    }
                                });
                            }}
                        />
                    </Grid>
                </Grid>
            </Paper>

            <NavigationButtons
                allowBack={allowBack}
                allowNext={allowNext}
                backStep={backStep}
                nextStep={nextStep}
                onNext={onNext}
                activeStep={activeStep}
                steps={steps}

                formattedProfile={formattedProfile}
                profileType={profileType}
            />
        </Grid>
    )
}
